import { createTypedLogger } from '../utils/typedLogger';

export type PlaceResult = google.maps.places.PlaceResult;
export type AutocompleteService = google.maps.places.AutocompleteService;
export type AutocompletionRequest = google.maps.places.AutocompletionRequest;
export type AutocompletePrediction = google.maps.places.AutocompletePrediction;
export type PlacesServiceStatus = google.maps.places.PlacesServiceStatus;
export type LatLngLiteral = google.maps.LatLngLiteral;
export type Geocoder = google.maps.Geocoder;
export type GeocoderRequest = google.maps.GeocoderRequest;
export type GeocoderStatus = google.maps.GeocoderStatus;
export type GeocoderResult = google.maps.GeocoderResult;
export type GeocoderAddressComponent = google.maps.GeocoderAddressComponent;

interface AutocompleteResponse {
  predictions: AutocompletePrediction[] | null;
  status: PlacesServiceStatus;
}

interface GeocoderResponse {
  results: GeocoderResult[] | null | [];
  status: GeocoderStatus;
}

const customLogger = createTypedLogger('api');

export class Places {
  logger: any;
  constructor() {
    this.logger = customLogger;
  }

  async geocode(request: GeocoderRequest): Promise<GeocoderResponse> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return new Promise<GeocoderResponse>((resolve, reject) => {
      try {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode(request, (results, status) => {
          if (
            status === google.maps.GeocoderStatus.OK ||
            status === google.maps.GeocoderStatus.ZERO_RESULTS
          ) {
            this.logger.debug(
              `Google Map GeocodeService.Search api request succeeded with status ${status}`,
              {
                req: request,
              },
            );
          } else {
            this.logger.error(
              `Google Map GeocodeService.Search api request failed with status ${status}`,
              {
                req: request,
              },
            );
          }
          resolve({ results: results, status: status });
        });
      } catch (err) {
        this.logger.error(
          `Google Map GeocodeService.Search api request failed with error ${JSON.stringify(
            err,
          )}`,
          {
            req: request,
          },
        );
      }
    });
  }

  async getPlacePredictions(
    request: AutocompletionRequest,
  ): Promise<AutocompleteResponse> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return new Promise<AutocompleteResponse>((resolve, reject) => {
      try {
        const service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions(request, (predictions, status) => {
          if (
            status === google.maps.places.PlacesServiceStatus.OK ||
            status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS
          ) {
            this.logger.debug(
              `Google Map AutocompleteService.getPlacePredictions api request succeeded with status ${status}`,
              {
                req: request,
              },
            );
          } else {
            this.logger.error(
              `Google Map AutocompleteService.getPlacePredictions api request failed with status ${status}`,
              {
                req: request,
              },
            );
          }
          resolve({ predictions: predictions, status: status });
        });
      } catch (err) {
        this.logger.error(
          `Google Map AutocompleteService.getPlacePredictions api request failed with error ${JSON.stringify(
            err,
          )}`,
          {
            req: request,
          },
        );
      }
    });
  }
}
